import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-50 flex items-center justify-center planner-template-status-modal"
}
const _hoisted_2 = { class: "flex items-center justify-center min-h-screen text-center" }
const _hoisted_3 = { class: "bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-5xl w-full" }
const _hoisted_4 = { class: "bg-white px-6 pt-6 pb-5 sm:p-8 sm:pb-6" }
const _hoisted_5 = { class: "flex justify-between items-start" }
const _hoisted_6 = { class: "mt-6" }
const _hoisted_7 = { class: "bg-gray-50 p-4 rounded-md" }
const _hoisted_8 = { class: "space-y-2 max-h-[50vh] overflow-y-auto" }
const _hoisted_9 = { class: "text-sm flex-1" }
const _hoisted_10 = { class: "w-32 text-center" }
const _hoisted_11 = ["onClick", "disabled"]
const _hoisted_12 = {
  key: 0,
  class: "animate-spin -ml-1 mr-1 h-3 w-3 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_13 = { class: "bg-gray-50 px-6 py-4 sm:px-8 flex justify-between" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "animate-spin -ml-1 mr-2 h-4 w-4 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "fixed inset-0 transition-opacity",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }, _cache[4] || (_cache[4] = [
            _createElementVNode("div", { class: "absolute inset-0 bg-gray-500 opacity-75" }, null, -1)
          ])),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[6] || (_cache[6] = _createElementVNode("div", null, [
                  _createElementVNode("h3", { class: "text-xl leading-6 font-semibold text-gray-900" }, " Planner Template Status "),
                  _createElementVNode("p", { class: "mt-2 text-sm text-gray-600" }, " Prepare templates for planners ")
                ], -1)),
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
                  class: "text-gray-400 hover:text-gray-500"
                }, _cache[5] || (_cache[5] = [
                  _createElementVNode("svg", {
                    class: "h-6 w-6",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ]))
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "flex mb-2" }, [
                    _createElementVNode("span", { class: "text-sm font-medium text-gray-700 flex-1" }, "Planner Type"),
                    _createElementVNode("span", { class: "text-sm font-medium text-gray-700 w-32 text-center" }, "Status"),
                    _createElementVNode("span", { class: "text-sm font-medium text-gray-700 w-32 text-center" }, "Action")
                  ], -1)),
                  _createElementVNode("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plannerStatus, (status, type) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: type,
                        class: _normalizeClass(["flex items-center p-2 rounded-md", status.exists ? 'bg-green-50' : 'bg-red-50'])
                      }, [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(type), 1),
                        _createElementVNode("span", {
                          class: _normalizeClass(["px-2 py-1 text-xs font-medium rounded-full w-24 text-center", status.exists ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'])
                        }, _toDisplayString(status.exists ? 'Available' : 'Missing'), 3),
                        _createElementVNode("div", _hoisted_10, [
                          (!status.exists)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: ($event: any) => (_ctx.preparePlannerTemplate(type)),
                                disabled: status.loading,
                                class: "px-4 py-1.5 text-sm bg-primary text-white rounded hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center w-20 mx-auto"
                              }, [
                                (status.loading)
                                  ? (_openBlock(), _createElementBlock("svg", _hoisted_12, _cache[7] || (_cache[7] = [
                                      _createElementVNode("circle", {
                                        class: "opacity-25",
                                        cx: "12",
                                        cy: "12",
                                        r: "10",
                                        stroke: "currentColor",
                                        "stroke-width": "4"
                                      }, null, -1),
                                      _createElementVNode("path", {
                                        class: "opacity-75",
                                        fill: "currentColor",
                                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                      }, null, -1)
                                    ])))
                                  : _createCommentVNode("", true),
                                _createTextVNode(" " + _toDisplayString(status.loading ? 'Creating...' : 'Create'), 1)
                              ], 8, _hoisted_11))
                            : _createCommentVNode("", true)
                        ])
                      ], 2))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.prepareAllMissingTemplates && _ctx.prepareAllMissingTemplates(...args))),
                disabled: _ctx.isAnyLoading || !_ctx.hasMissingTemplates,
                class: "inline-flex justify-center rounded-md border border-primary shadow-sm px-5 py-2.5 bg-primary text-white text-base font-medium hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-50 disabled:cursor-not-allowed"
              }, [
                (_ctx.isAllLoading)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_15, _cache[9] || (_cache[9] = [
                      _createElementVNode("circle", {
                        class: "opacity-25",
                        cx: "12",
                        cy: "12",
                        r: "10",
                        stroke: "currentColor",
                        "stroke-width": "4"
                      }, null, -1),
                      _createElementVNode("path", {
                        class: "opacity-75",
                        fill: "currentColor",
                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      }, null, -1)
                    ])))
                  : _createCommentVNode("", true),
                _cache[10] || (_cache[10] = _createTextVNode(" Create All Missing "))
              ], 8, _hoisted_14),
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
                class: "inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-5 py-2.5 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              }, " Close ")
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}